//FIXME Button currently has an outstanding issue https://github.com/ant-design/ant-design/issues/22493 which throws "findDOMNode was passed an instance of Wave which is inside StrictMode"
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
//FIXME Button currently has an outstanding issue https://github.com/ant-design/ant-design/issues/22493 which throws "findDOMNode was passed an instance of Wave which is inside StrictMode"
import { Menu, Dropdown, Button } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import classnames from 'classnames';
import { Icon, IconImage } from 'src/modules/global/components/icon/Icon';
import styles from './FormFieldDropdown.module.scss';
import { GlobalIcon } from 'src/modules/global';

export interface FormFieldDropdownItem {
  id: string;
  name: string;
}

export interface FormFieldDropdownProps extends FormItemProps {
  value?: FormFieldDropdownItem[];
  onChange?: (value: FormFieldDropdownItem[]) => void;
  label?: string;
  labelKey?: string;
  className?: string;
  items: FormFieldDropdownItem[];
  onSave?: () => void;
}

export const FormFieldDropdown = (props: FormFieldDropdownProps) => {
  const { value: activeFilters = [], className, items, label, labelKey, onSave, onChange } = props;

  // State to keep/set the visibility of the dropdown menu, so it can be closed upon clicking on buttons
  const [menuVisibility, setMenuVisibility] = useState<boolean>(false);
  const [isDirty, setDirty] = useState<boolean>(false);

  const activeFiltersNum = activeFilters.length;

  const _handleVisibleChange = (flag) => {
    setMenuVisibility(flag);
    // If user clicks outside the Menu, save selected filters
    !flag && isDirty && save();
  };

  const isSelected = (item: FormFieldDropdownItem) =>
    activeFilters.findIndex((i) => i.id === item.id) > -1;

  const _onClickMenuItem = (item) => {
    onChange(
      isSelected(item) ? activeFilters.filter((i) => i.id !== item.id) : [...activeFilters, item]
    );
    setDirty(true);
  };

  const _onClickSave = () => {
    setMenuVisibility(false);
    save();
  };

  const _onClickReset = () => {
    onChange([]);
    setMenuVisibility(false);
    save();
  };

  const save = () => {
    onSave && onSave();
    setDirty(false);
  };

  const menu = items && (
    <div className={styles.menuContainer}>
      <Menu className={styles.menu}>
        {items.map((item) => (
          <Menu.Item
            key={item.id}
            className={classnames(styles.menuItem, isSelected(item) && styles.active)}
            onClick={_onClickMenuItem.bind(null, item)}>
            <div className={styles.menuItemLabel}>{item.name}</div>
            <GlobalIcon image={IconImage.Check} className={styles.activeIcon} />
          </Menu.Item>
        ))}
      </Menu>
      <div className={styles.actionsContainer}>
        {!!activeFiltersNum && (
          <Button className={styles.resetButton} type="link" onClick={_onClickReset}>
            <FormattedMessage id="filters/buttons/reset" />
          </Button>
        )}
        <Button className={styles.saveButton} type="primary" size="large" onClick={_onClickSave}>
          <FormattedMessage id="filters/buttons/save" />
        </Button>
      </div>
    </div>
  );

  return (
    <div className={classnames(styles.container, className)}>
      <Dropdown
        overlay={menu}
        visible={menuVisibility}
        onVisibleChange={_handleVisibleChange}
        trigger={['click']}>
        <a className={styles.button} onClick={(e) => e.preventDefault()}>
          {(labelKey && <FormattedMessage id={labelKey} />) || label}
          {!!activeFiltersNum && ` (${activeFiltersNum})`}
          <Icon
            image={IconImage.DownArrow}
            size="custom"
            className={classnames(styles.menuArrow, menuVisibility && styles.isOpen)}
          />
        </a>
      </Dropdown>
    </div>
  );
};

export default FormFieldDropdown;
